import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectEditCreatorState = (state) => state.editCreator || initialState;

export const selectEditCreator = createSelector(
  [selectEditCreatorState],
  (editCreatorState) => editCreatorState.editCreator
);

export const selectUpdateCreator = createSelector(
  [selectEditCreatorState],
  (editCreatorState) => editCreatorState.updateCreator
);
